// src/pages/About.js
import React from "react";
import { Link } from "react-router-dom";
import "../index.css";
import useSEO from "../seo/useSEO";

export default function About() {
  useSEO({
    title: "À propos — HLBK • Photographe à Tomblaine",
    description:
      "Photographe basé à Tomblaine. Portraits, mariages, événements et corporate. Une approche humaine, lumineuse et simple du premier contact à la livraison.",
    canonical: `${window.location.origin}/about`,
    image: `${window.location.origin}/images/og-default.jpg`,
  });

  return (
    <section className="aboutx">
      {/* HERO */}
      <header className="aboutx-hero">
        <p className="eyebrow">HLBK — Maxime Huylebroeck</p>
        <h1>Des photos vraies, lumineuses, qui racontent votre histoire.</h1>
        <p className="lead">
          Basé à Tomblaine, j’accompagne particuliers et entreprises dans le Grand Est (et au-delà)
          avec une approche simple : écoute, discrétion, belles lumières… et des images
          prêtes à être partagées ou imprimées.
        </p>

        <div className="aboutx-cta">
          <Link to="/contact" className="btn-solid">Demander un devis</Link>
          <Link to="/services" className="btn-ghost">Voir mes services</Link>
        </div>

        <ul className="aboutx-badges" aria-label="Infos clés">
          <li>⏱ Réponse &lt; 24h</li>
          <li>🇫🇷🇧🇪🇱🇺 Déplacements</li>
          <li>🖼 Idéal pour Web & Print</li>
        </ul>
      </header>

      {/* VALEURS */}
      <section className="aboutx-values">
        <article className="vcard">
          <div className="vico" aria-hidden>✨</div>
          <h3>Authenticité</h3>
          <p>Des images naturelles, sans artifices, qui laissent place aux émotions.</p>
        </article>
        <article className="vcard">
          <div className="vico" aria-hidden>📸</div>
          <h3>Polyvalence</h3>
          <p>Portrait, mariage, événementiel, corporate : un style cohérent, plusieurs univers.</p>
        </article>
        <article className="vcard">
          <div className="vico" aria-hidden>🤝</div>
          <h3>Proximité</h3>
          <p>Un accompagnement clair, du brief à la livraison. Vous savez où on va, à chaque étape.</p>
        </article>
      </section>

      {/* MÉTHODE EN 3 ÉTAPES */}
      <section className="aboutx-steps">
        <h2>Comment ça se passe ?</h2>
        <ol className="steps">
          <li>
            <span className="num">1</span>
            <h4>Écoute & préparation</h4>
            <p>Vos attentes, vos contraintes, votre style. Je propose un cadre simple et efficace.</p>
          </li>
          <li>
            <span className="num">2</span>
            <h4>Prise de vue sereine</h4>
            <p>Direction douce, lumière soignée, et beaucoup de spontanéité pour des images vraies.</p>
          </li>
          <li>
            <span className="num">3</span>
            <h4>Sélection & livraison</h4>
            <p>Galerie privée, fichiers HD optimisés web & print, prêts à partager ou imprimer.</p>
          </li>
        </ol>
      </section>

      {/* ZONE “POUR QUI” */}
      <section className="aboutx-for">
        <h2>Pour qui ?</h2>
        <ul className="chips">
          <li>Couples & mariages</li>
          <li>Portraits individuels & familles</li>
          <li>Entreprises & indépendants</li>
          <li>Événements privés & pros</li>
        </ul>
      </section>

      {/* BANNIÈRE CTA */}
      <aside className="aboutx-banner">
        <h3>Prêt·e à créer de belles images ?</h3>
        <p>Je vous réponds sous 24h avec une proposition claire et adaptée.</p>
        <Link to="/contact" className="btn-solid">Parler de votre projet</Link>
      </aside>
    </section>
  );
}